<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title>
      <span class="headline">Редактирование Пользователя</span>
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="back">Назад</v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="isValid" ref="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              label="Фамилия Имя (Отчество)"
              v-model="user.fullName"
              :rules="[notEmptyRule]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Телефон"
              v-model="user.phone"
              :rules="[notEmptyRule, length50]"
              counter="50"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              label="Email"
              v-model="user.email"
              :rules="[notEmptyRule, emailIsUnique, emailRule]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <!--            <v-btn-->
            <!--                v-if="!user.changePassword"-->
            <!--                class="d-block mx-auto"-->
            <!--                color="green"-->
            <!--                dark-->
            <!--                @click="user.changePassword = true"-->
            <!--            >Изменить пароль-->
            <!--            </v-btn>-->
            <v-text-field ref="password" label="Пароль" v-model="user.password">
              <template v-slot:append>
                <v-btn text x-small @click="user.password = generatePassword()">
                  Случайный
                </v-btn>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="user.dealer"
              :items="choices.dealers"
              label="Дилер"
              no-data-text="Дилер не найден"
              :rules="[notEmptyRule]"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="user.role"
              :items="choices.roles"
              label="Роль"
              :rules="[roleIsSet]"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6">
            <v-switch
              v-model="user.receiveEmails"
              label="Получать рассылку"
              hint="Предупреждение (за 10 дней) об окончании лицензии на почту"
              persistent-hint
            >
            </v-switch>
          </v-col>

          <v-col cols="12" sm="6">
            <v-switch
              v-model="user.sendNotification"
              label="Уведомить на почту"
              hint="Пользователь получит письмо на указанный Email"
              persistent-hint
            ></v-switch>
          </v-col>

          <v-col cols="12" sm="6" v-if="canManageSystemUser">
            <v-switch
              v-model="user.isSystemUser"
              label="Системный пользователь"
              hint="Пользователь для системных задач"
              persistent-hint
            ></v-switch>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              label="Изменил"
              v-model="user.creatorName"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Дата последнего изменения"
              v-model="formatUpdateTime"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary darken-1"
        text
        @click="updateUserData"
        :disabled="!isValid"
        >Сохранить
      </v-btn>
    </v-card-actions>

    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";

export default {
  name: "UserEdit",
  props: ["userId"],
  data() {
    return {
      loading: true,
      user: {},
      choices: {
        dealers: [],
        roles: [],
      },
      takenEmails: [],
      isValid: false,
      notEmptyRule: (v) => !!v || "Поле не может быть пустым",
      roleIsSet: (v) => v >= 0 || "Не указана роль",
      emailIsUnique: (v) =>
        (v && !this.takenEmails.includes(v)) || "Этот Email уже занят",
      emailRule: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) ||
        "Неверный формат email",
      length50: (v) => (v && v.length <= 50) || "Максимум 50 символов",
    };
  },
  methods: {
    back() {
      history.back();
    },
    generatePassword() {
      return Array(10)
        .fill(
          "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$"
        )
        .map(
          (x) =>
            x[
              Math.floor(
                (crypto.getRandomValues(new Uint32Array(1))[0] /
                  (0xffffffff + 1)) *
                  x.length
              )
            ]
        )
        .join("");
    },
    getRoleChoices() {
      API.get("users/roles/choices")
        .then((response) => {
          this.choices.roles = response.data.choices;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getUserData() {
      await API.get(`users/${this.userId}`)
        .then((response) => {
          console.log(response.data);
          this.user = response.data.user;
          this.$set(this.user, "password", "");
          // this.$set(this.user, 'changePassword', false);
          this.$set(this.user, "sendNotification", true);
          this.$set(this.user, "isSystemUser", !!this.user.isSystemUser);
        })
        .catch((error) => {
          console.log(error.response.data);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
          history.back();
        });
    },
    getDealerChoices() {
      API.get("dealers/choices")
        .then((response) => {
          console.log(response.data);
          this.choices.dealers = response.data.choices;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getTakenEmails() {
      await API.get("users/emails")
        .then((response) => {
          console.log(response.data);
          this.takenEmails = response.data.emails;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateUserData() {
      API.post(`users/${this.userId}`, this.user)
        .then((response) => {
          console.log(response.data);
          this.$store.commit("showSnackbar", {
            color: "success",
            text: "Информация обновлена",
          });
          this.getUserData();
          // this.user.changePassword = false;
          this.$store.dispatch("updateUsers");
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("showSnackbar", {
            color: "error",
            text: "Информация не обновлена",
          });
        });
    },
  },
  computed: {
    canManageSystemUser() {
      return this.$store.getters.user.roleId === 0;
    },
    formatUpdateTime() {
      if (this.user.updateTime == null) return "";
      return FormatDateTime(this.user.updateTime);
    },
  },
  created() {
    this.loading = true;
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "users", disabled: false, to: "/users", exact: true },
      { text: this.userId, disabled: true },
    ]);
    this.getDealerChoices();
    this.getRoleChoices();
    this.getTakenEmails().then(() =>
      this.getUserData().then(() => {
        this.takenEmails.splice(this.takenEmails.indexOf(this.user.email), 1);
        this.$refs.form.validate();
        this.loading = false;
      })
    );
  },
};
</script>